<template>
    <modal name="modal-ideals-offline"
           class="dd-m-modal dd-m-modal--product-list">

        <main class="dd-l-container dd-l-container--my-collection">
            <div class="dd-l-container__wrapper">
                <div class="dd-l-container__content dd-l-container--my-collection__container">

                    <section class="dd-l-section--my-collection">
                        <div class="dd-l-container__wrapper dd-l-container__wrapper--content">
                            <div class="dd-m-extra--section-header">
                                <h1 class="dd-m-extra--section-header__title">
                                    Ideal Perfumes
                                </h1>

                                <span class="dd-m-helper--detail-row"></span>

                                <header class="dd-m-modal--product-list__header">
                                    <button @click.prevent="hide"
                                            class="dd-m-button dd-m-button--auto dd-m-button--assertive dd-m-button--circled">
                                        <i class="icon-close"></i>
                                    </button>
                                </header>
                            </div>

                            <div class="dd-m-extra--section-description">
                                <h2>
                                    Todas as fragrâncias Avon que você mais gosta, prontas para quando você precisar
                                </h2>
                            </div>

                            <div class="dd-l-grid dd-l-grid--category-products dd-l-grid--category-products-custom">
                                <div class="dd-l-grid--category-products__container">
                                    <div v-if="products.length" class="dd-l-grid--category-products__content">
                                        <div class="dd-l-grid--category-products__list">
                                            <card-custom-category-product-offline v-for="(item, index) in products"
                                                                          :item="item"
                                                                          :key="index"></card-custom-category-product-offline>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>

    </modal>
</template>
<script>
    import CardCustomCategoryProductOffline from "../products/card-custom-category-product-offline";

    export default {
        name: 'modal-ideals-offline',
        components: {CardCustomCategoryProductOffline},
        data: () => {
            return {
                products: [],
                hasLoaded: false
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('openIdealsOffline', (msg, param) => {
                    this.retrieveProducts(param);
                    this.show();
                });

                PubSub.subscribe('closeIdealsOffline', () => this.hide());
            },
            show() {
                this.$modal.show('modal-ideals-offline');
            },
            hide() {
                this.$modal.hide('modal-ideals-offline');
            },
            retrieveProducts(needscopeId) {
                try {
                    let allProducts = JSON.parse(localStorage.products);
                    allProducts.map((product) => product.needscopes.map((needscope) => {
                        if (needscope.id === needscopeId) {
                            this.products.push(product);
                        }
                    }));

                    this.hasLoaded = true;
                } catch (e) {
                    this.hasLoaded = true;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/custom-modals/modal-ideals-offline.vue